export const translations = {
    en: {
        nav: {
            home: "Home",
            story: "Our Story",
            franchise: "Franchise",
            faq: "FAQ",
            outlets: "Outlets",
            contact: "Contact",
            enquiry: "Franchise Enquiry"
        },
        hero: {
            headline: "India's Growing Pizza Franchise – Built on Quality, Not Hype",
            subline: "100% hygiene • 100% support • 100% transparency",
            ctaPrimary: "Explore Our Story",
            ctaSecondary: "Start Your Franchise Journey",
            badge: "Now Accepting Franchise Partners"
        },
        story: {
            badge: "Our Journey",
            title: "The Pizzatoons",
            highlight: "Story",
            subtitle: "From a single dream to 48 thriving outlets",
            sections: [
                { title: "The Beginning", text: "We didn't start with marketing, we started with quality.", year: "2019" },
                { title: "First Smiles", text: "Customers became our promoters.", year: "2019" },
                { title: "Growing Family", text: "Franchisees became our family.", year: "2021" },
                { title: "Pune & Beyond", text: "Strategic expansion across Pune & PCMC.", year: "2024" }
            ]
        },
        founder: {
            badge: "The Visionary",
            title: "Meet the",
            highlight: "Founder",
            message: "Pizzatoons was never about opening outlets fast, it was about doing things right. Every pizza we make carries our promise of quality. Every franchise we open is a partnership built on trust. We believe in growing together – one slice at a time.",
            quote: "Quality is not an act, it's a habit."
        },
        stats: {
            outlets: "Outlets",
            customers: "Customers Served",
            retention: "Franchise Retention",
            years: "Years of Excellence",
            highlight: "🚫 No Paid Marketing – ✅ Only Word of Mouth & Repeat Customers"
        },
        supplyChain: {
            badge: "Our Backbone",
            title: "Strong",
            highlight: "Supply Chain",
            subtitle: "Consistent quality delivered to your doorstep every single day",
            items: [
                { title: "Central Kitchen", description: "State-of-the-art facility ensuring consistent quality" },
                { title: "Warehouse", description: "Strategic storage with optimal conditions" },
                { title: "Cold Chain", description: "Temperature-controlled delivery network" },
                { title: "Daily Dispatch", description: "Fresh ingredients delivered every day" }
            ]
        },
        comparison: {
            badge: "Why Pizzatoons?",
            title: "Kiosk vs",
            highlight: "Store Model",
            subtitle: "Why we choose sustainability over temporary trends",
            kiosk: {
                title: "Kiosk Model",
                items: ["Hygiene concerns", "Rain & weather problems", "Corporation compliance issues", "No seating arrangement", "Limited menu options"]
            },
            store: {
                title: "Store Model",
                items: ["Premium look & feel", "FSSAI compliant", "Better sales potential", "Brand trust & recognition", "Comfortable dining experience"]
            }
        },
        franchise: {
            badge: "Partnership Model",
            title: "Franchise",
            highlight: "Journey",
            subtitle: "Your roadmap to becoming a PizzaToons family member",
            investment: "Investment",
            model: "Model",
            ctaLabel: "Ready to start your journey?",
            ctaBtn: "Apply Now",
            steps: [
                { title: "Enquiry", description: "Fill out the franchise enquiry form" },
                { title: "Discussion", description: "Have a detailed discussion with our team" },
                { title: "Location", description: "Select and finalize your store location" },
                { title: "Agreement", description: "Sign the franchise agreement" },
                { title: "Setup", description: "Store setup with our guidance" },
                { title: "Training", description: "Complete training program" },
                { title: "Launch", description: "Grand opening of your outlet" },
                { title: "Support", description: "Ongoing support & assistance" }
            ]
        },
        faq: {
            badge: "Got Questions?",
            title: "Franchise",
            highlight: "FAQ",
            subtitle: "Everything you need to know about partnering with PizzaToons",
            cta: "Still have questions? Contact our support team",
            items: [
                { q: "Franchise Available?", a: "Yes ✅ Limited areas available. Please go through our outlet section to check availability." },
                { q: "Investment required?", a: "₹12–15 Lakhs (Approx.) Setup, branding, training & support included." },
                { q: "Location Requirement", a: "✔ Ground floor\n✔ 250–400 sq.ft\n✔ Good visibility" },
                { q: "I don't have location. Help?", a: "Yes ✅ Authorized brokers provide location help." },
                { q: "Kiosk/ Counter Model?", a: "No ❌ Only Store Model is available now." },
                { q: "Profit / Income?", a: "Depends on location and management. With proper operations, good profit is possible." },
                { q: "Training & Support?", a: "Yes ✅ Full training and continuous support provided." },
                { q: "Raw material?", a: "Company provides centralized supply." },
                { q: "Outlet Start Timeline?", a: "Starts in 20–25 days after approval." },
                { q: "Already Applied?", a: "Our team will contact you soon. If delayed, reply CALLBACK." },
                { q: "Area Availability?", a: "Send your area name 📍 We will check and inform you." },
                { q: "Talk to Team?", a: "Reply CONNECT 📞 Executive will call you." }
            ]
        },
        contact: {
            badge: "Get in Touch",
            title: "Contact",
            highlight: "Us",
            subtitle: "Have questions about our franchise or outlets? We're here to help.",
            workingHours: "Working Hours",
            email: "Email Address",
            phone: "Phone Number",
            address: "Office Address"
        },
        enquiry: {
            title: "Start Your",
            highlight: "Franchise Journey",
            subtitle: "Fill in your details and we'll get back to you within 24 hours",
            nameLabel: "Full Name",
            namePlaceholder: "Enter your full name",
            mobileLabel: "Mobile Number",
            mobilePlaceholder: "Enter your 10-digit mobile number",
            cityLabel: "City / Area",
            cityPlaceholder: "e.g., Pune - Kothrud",
            investmentLabel: "Investment Readiness",
            investmentPlaceholder: "Select your investment readiness",
            investmentOptions: [
                { value: "ready", label: "Ready to invest immediately" },
                { value: "3months", label: "Within 3 months" },
                { value: "6months", label: "Within 6 months" },
                { value: "exploring", label: "Just exploring" }
            ],
            submitBtn: "Submit Enquiry",
            submittingBtn: "Sending...",
            consent: "By submitting, you agree to be contacted by our franchise team",
            successTitle: "Welcome to the PizzaToons Family! 🎉",
            successSubtitle: "Thank you for your interest! Our team will contact you within 24 hours.",
            resetBtn: "Submit Another Enquiry"
        },
        outlets: {
            badge: "Our Presence",
            title: "Explore",
            highlight: "Outlet Locations",
            subtitle: "Find a PizzaToons outlet near you",
            allZones: "All Zones",
            zoneLegend: "Zone Legend",
            directions: "Directions",
            call: "Call",
            address: "Address",
            contact: "Contact",
            callNow: "Call Now",
            getDirections: "Get Directions",
            searchPlaceholder: "Search by outlet name or area...",
            ourOutlets: "Our Outlets",
            viewOnMap: "Click to view on map"
        },
        testimonials: {
            badge: "Success Stories",
            title: "Franchise Owner",
            highlight: "Testimonials",
            subtitle: "Real stories from real owners - no scripts, just truth",
            cta: "Start Your Success Story",
            ctaSubtitle: "Begin your journey with Zero {highlight} & 100% Support",
            ctaHighlight: "Marketing Cost",
            videoTitles: [
                "How Friends Opened 5 PizzaToons Outlet In Just 1 Year | Success Story | Pizzatoons",
                "Don't Underestimate Women Entrepreneurs | How She Earns In Lakhs | Pizzatoons",
                "From Customer to Franchise Owner | Employee to Boss Story | Pizzatoons",
                "I Quit My IT Job for This! 😳🍕 | Pizzatoons Success Story"
            ]
        }
    },
    mr: {
        nav: {
            home: "मुख्यपृष्ठ",
            story: "आमची गोष्ट",
            franchise: "फ्रँचायझी",
            faq: "प्रश्नावली",
            outlets: "आउटलेट्स",
            contact: "संपर्क",
            enquiry: "फ्रँचायझी चौकशी"
        },
        hero: {
            headline: "भारतातील वेगाने वाढणारी पिझ्झा फ्रँचायझी - गुणवत्तेवर आधारित, हवेवर नाही",
            subline: "१००% स्वच्छता • १००% समर्थन • १००% पारदर्शकता",
            ctaPrimary: "आमची गोष्ट एक्सप्लोर करा",
            ctaSecondary: "तुमचा फ्रँचायझी प्रवास सुरू करा",
            badge: "आता फ्रँचायझी भागीदार स्वीकारत आहोत"
        },
        story: {
            badge: "आमचा प्रवास",
            title: "पिझ्झाटून्सची",
            highlight: "गोष्ट",
            subtitle: "एका स्वप्नापासून ४८ यशस्वी आउटलेट्सपर्यंत",
            sections: [
                { title: "सुरुवात", text: "आम्ही मार्केटिंगने नाही, तर गुणवत्तेने सुरुवात केली.", year: "२०१९" },
                { title: "पहिली हास्य", text: "ग्राहकच आमचे प्रसारक बनले.", year: "२०१९" },
                { title: "वाढते कुटुंब", text: "फ्रँचायझीधारक आमचे कुटुंब बनले.", year: "२०२१" },
                { title: "पुणे आणि पुढे", text: "पुणे आणि पिंपरी-चिंचवडमध्ये धोरणात्मक विस्तार.", year: "२०२४" }
            ]
        },
        founder: {
            badge: "दूरदर्शी",
            title: "भेटा आमचे",
            highlight: "संस्थापक",
            message: "पिझ्झाटून्स कधीही वेगाने आउटलेट्स उघडण्याबद्दल नव्हते, तर गोष्टी योग्यरित्या करण्याबद्दल होते. आम्ही बनवलेला प्रत्येक पिझ्झा आमच्या गुणवत्तेचे वचन देतो. आम्ही उघडलेली प्रत्येक फ्रँचायझी ही विश्वासावर आधारित भागीदारी आहे. आमचा एकत्र वाढण्यावर विश्वास आहे.",
            quote: "गुणवत्ता ही कृती नाही, तर ती एक सवय आहे."
        },
        stats: {
            outlets: "आउटलेट्स",
            customers: "सेवा दिलेले ग्राहक",
            retention: "फ्रँचायझी टिकून राहण्याचे प्रमाण",
            years: "उत्कृष्टतेची वर्षे",
            highlight: "🚫 कोणतीही सशुल्क जाहिरात नाही – ✅ फक्त शब्दातून शब्द आणि पुनरावृत्ती ग्राहक"
        },
        supplyChain: {
            badge: "आमचा कणा",
            title: "भक्कम",
            highlight: "पुरवठा साखळी",
            subtitle: "दररोज तुमच्या दारापर्यंत पोहोचणारी सातत्यपूर्ण गुणवत्ता",
            items: [
                { title: "मध्यवर्ती स्वयंपाकघर", description: "सातत्यपूर्ण गुणवत्ता सुनिश्चित करणारी अत्याधुनिक सुविधा" },
                { title: "गोदाम", description: "इष्टतम परिस्थितीसह धोरणात्मक साठा" },
                { title: "कोल्ड चेन", description: "तापमान-नियंत्रित वितरण नेटवर्क" },
                { title: "दैनिक प्रेषण", description: "दररोज पोहोचवले जाणारे ताजे घटक" }
            ]
        },
        comparison: {
            badge: "का पिझ्झाटून्स?",
            title: "किओस्क विरुद्ध",
            highlight: "स्टोअर मॉडेल",
            subtitle: "आम्ही तात्पुरत्या ट्रेड्सऐवजी टिकाऊपणा का निवडतो",
            kiosk: {
                title: "किओस्क मॉडेल",
                items: ["स्वच्छतेच्या चिंता", "पाऊस आणि हवामानाच्या समस्या", "महानगरपालिका अनुपालन समस्या", "बैठक व्यवस्था नाही", "मर्यादित मेनू पर्याय"]
            },
            store: {
                title: "स्टोअर मॉडेल",
                items: ["प्रीमियम लूक आणि फील", "FSSAI अनुपालन", "उत्तम विक्री क्षमता", "ब्रँड विश्वास आणि ओळख", "आरामदायक जेवणाचा अनुभव"]
            }
        },
        franchise: {
            badge: "भागीदारी मॉडेल",
            title: "फ्रँचायझी",
            highlight: "प्रवास",
            subtitle: "पिझ्झाटून्स कुटुंबाचे सदस्य होण्यासाठी तुमचा रोडमॅप",
            investment: "गुंतवणूक",
            model: "मॉडेल",
            ctaLabel: "तुमचा प्रवास सुरू करण्यास तयार आहात का?",
            ctaBtn: "आता अर्ज करा",
            steps: [
                { title: "चौकशी", description: "फ्रँचायझी चौकशी फॉर्म भरा" },
                { title: "चर्चा", description: "आमच्या टीमसोबत तपशीलवार चर्चा करा" },
                { title: "जागा", description: "तुमच्या स्टोअरची जागा निवडा आणि अंतिम करा" },
                { title: "करार", description: "फ्रँचायझी करारावर स्वाक्षरी करा" },
                { title: "सेटअप", description: "आमच्या मार्गदर्शनाखाली स्टोअर सेटअप करा" },
                { title: "प्रशिक्षण", description: "पूर्ण प्रशिक्षण कार्यक्रम" },
                { title: "लाँच", description: "तुमच्या आउटलेटचे भव्य उद्घाटन" },
                { title: "समर्थन", description: "सतत समर्थन आणि सहाय्य" }
            ]
        },
        faq: {
            badge: "काही प्रश्न आहेत?",
            title: "फ्रँचायझी",
            highlight: "प्रश्नावली",
            subtitle: "पिझ्झाटून्ससोबत भागीदारी करण्याबद्दल तुम्हाला माहित असणे आवश्यक असलेली प्रत्येक गोष्ट",
            cta: "तरीही काही प्रश्न आहेत? आमच्या सपोर्ट टीमशी संपर्क साधा",
            items: [
                { q: "फ्रँचायझी उपलब्ध आहे का?", a: "हो ✅ मर्यादित क्षेत्रे उपलब्ध आहेत. कृपया उपलब्धतेसाठी आमचे 'आउटलेट्स' विभाग तपासा." },
                { q: "गुंतवणूक किती आहे?", a: "₹१२–१५ लाख (अंदाजे) सेटअप, ब्रँडिंग, प्रशिक्षण आणि सपोर्ट समाविष्ट आहे." },
                { q: "जागेची आवश्यकता काय आहे?", a: "✔ तळमजला\n✔ २५०–४०० चौ.फूट\n✔ चांगली दृश्यमानता" },
                { q: "माझ्याकडे जागा नाही. मदत कराल का?", a: "हो ✅ अधिकृत ब्रोकर्समार्फत जागेसाठी मदत केली जाते." },
                { q: "किओस्क/काउंटर मॉडेल उपलब्ध आहे का?", a: "नाही ❌ आता फक्त स्टोअर मॉडेल उपलब्ध आहे." },
                { q: "नफा किती मिळतो?", a: "जागा आणि व्यवस्थापनावर अवलंबून असते. योग्य कामकाजासह चांगला नफा शक्य आहे." },
                { q: "प्रशिक्षण मिळेल का?", a: "हो ✅ पूर्ण प्रशिक्षण आणि सतत समर्थन दिले जाते." },
                { q: "कच्चा माल कोण देतो?", a: "कंपनी मध्यवर्ती पुरवठा देते." },
                { q: "आउटलेट किती दिवसात सुरू होतो?", a: "मंजुरीनंतर २०-२५ दिवसांत सुरू होतो." },
                { q: "मी आधीच अर्ज केला आहे. पुढे काय?", a: "आमची टीम लवकरच तुमच्याशी संपर्क करेल. उशीर झाल्यास CALLBACK रिप्लाय करा." },
                { q: "माझे क्षेत्र उपलब्ध आहे का?", a: "तुमच्या क्षेत्राचे नाव पाठवा 📍 आम्ही तपासून तुम्हाला कळवू." },
                { q: "टीमशी बोलायचे आहे.", a: "CONNECT रिप्लाय करा 📞 कार्यकारी तुम्हाला कॉल करेल." }
            ]
        },
        contact: {
            badge: "संपर्क साधा",
            title: "आमच्याशी",
            highlight: "बोला",
            subtitle: "आमच्या फ्रँचायझी किंवा आउटलेट्सबद्दल काही प्रश्न? आम्ही मदतीसाठी तयार आहोत.",
            workingHours: "कामाची वेळ",
            email: "ईमेल पत्ता",
            phone: "फोन नंबर",
            address: "कार्यालयाचा पत्ता"
        },
        enquiry: {
            title: "तुमचा",
            highlight: "फ्रँचायझी प्रवास सुरू करा",
            subtitle: "तुमचा तपशील भरा आणि आम्ही २४ तासांच्या आत तुमच्याशी संपर्क साधू",
            nameLabel: "पूर्ण नाव",
            namePlaceholder: "तुमचे पूर्ण नाव प्रविष्ट करा",
            mobileLabel: "मोबाईल नंबर",
            mobilePlaceholder: "तुमचा १० अंकी मोबाईल नंबर प्रविष्ट करा",
            cityLabel: "शहर / परिसर",
            cityPlaceholder: "उदा., पुणे - कोथरूड",
            investmentLabel: "गुंतवणुकीची तयारी",
            investmentPlaceholder: "तुमची गुंतवणुकीची तयारी निवडा",
            investmentOptions: [
                { value: "ready", label: "लगेच गुंतवणूक करण्यास तयार" },
                { value: "3months", label: "३ महिन्यांच्या आत" },
                { value: "6months", label: "६ महिन्यांच्या आत" },
                { value: "exploring", label: "फक्त माहिती घेत आहे" }
            ],
            submitBtn: "चौकशी सबमिट करा",
            submittingBtn: "पाठवत आहे...",
            consent: "सबमिट करून, तुम्ही आमच्या फ्रँचायझी टीमद्वारे संपर्क साधण्यास सहमत आहात",
            successTitle: "पिझ्झाटून्स परिवारात आपले स्वागत आहे! 🎉",
            successSubtitle: "तुमच्या स्वारस्याबद्दल धन्यवाद! आमची टीम २४ तासांच्या आत तुमच्याशी संपर्क साधेल.",
            resetBtn: "दुसरी चौकशी सबमिट करा"
        },
        outlets: {
            badge: "आमचे अस्तित्व",
            title: "आमची",
            highlight: "आउटलेट्स ठिकाणे",
            subtitle: "तुमच्या जवळचे पिझ्झाटून्स आउटलेट शोधा",
            allZones: "सर्व विभाग",
            zoneLegend: "विभाग सूची",
            directions: "दिशा",
            call: "कॉल करा",
            address: "पत्ता",
            contact: "संपर्क",
            callNow: "आता कॉल करा",
            getDirections: "मार्ग मिळवा",
            searchPlaceholder: "आउटलेटचे नाव किंवा परिसर शोधा...",
            ourOutlets: "आमचे आउटलेट्स",
            viewOnMap: "नकाशावर पाहण्यासाठी क्लिक करा"
        },
        testimonials: {
            badge: "यशोगाथा",
            title: "फ्रँचायझी मालकांचे",
            highlight: "अभिप्राय",
            subtitle: "खऱ्या मालकांच्या खऱ्या गोष्टी - कोणतीही स्क्रीप्ट नाही, फक्त सत्य",
            cta: "तुमची यशोगाथा सुरू करा",
            ctaSubtitle: "शून्य {highlight} आणि १००% समर्थनासह तुमचा प्रवास सुरू करा",
            ctaHighlight: "मार्केटिंग खर्च",
            videoTitles: [
                "फक्त १ वर्षात मित्रांनी ५ पिझ्झाटून्स आउटलेट्स कसे उघडले | यशोगाथा | पिझ्झाटून्स",
                "महिला उद्योजकांना कमी लेखू नका | ती लाखात कशी कमावते | पिझ्झाटून्स",
                "ग्राहकापासून फ्रँचायझी मालकापर्यंत | कर्मचाऱ्यापासून मालकापर्यंतची गोष्ट | पिझ्झाटून्स",
                "यासाठी मी माझी IT ची नोकरी सोडली! 😳🍕 | पिझ्झाटून्स सक्सेस स्टोरी"
            ]
        }
    }
};
